export default {"src":"/_next/static/media/logo.41d6421e.svg","height":500,"width":500};